import {
  ContinueButton,
  Container,
  EncryptionIcon,
  IntroScrollArea,
  IntroCard,
  IntroCardBody,
  IntroText,
  Logo,
  LogoWrapper,
  Progress,
  StaticHeader,
  SubTitle,
  Title,
} from "./styles";

type SplashPageProps = {
  isReady: boolean;
  onContinue: () => void;
  progress: number;
};

export default function SplashPage(props: SplashPageProps) {
  const { isReady, onContinue, progress } = props;

  return (
    <Container>
      <StaticHeader>
        <LogoWrapper>
          <Logo id="whatsapp" />
        </LogoWrapper>
        <Progress progess={progress} />
        <Title>WhatsApp</Title>
        <SubTitle>
          <EncryptionIcon id="lock" /> End-to-end encrypted. Built by Young Democrats 💙
        </SubTitle>
      </StaticHeader>
      <IntroScrollArea>
        <IntroCard>
          <IntroCardBody>
            <IntroText>
              אתר זה מציג את שיחות הווטסאפ שהודלפו מהטלפון של אלי פלדשטיין, שעבד עבור לשכת ראש
              הממשלה, ושחלק מהתכתבויותיו נחשפו בתקשורת לאחר מעצרו. הפרשה הזו התפזרה בתקשורת לעשרות
              פרטים, הדלפות וכיוונים שונים, אבל בסוף הדברים הם פשוטים.
            </IntroText>
            <IntroText>
              השיחות כאן עוקבות אחרי האופן שבו, מתוך לשכת ראש הממשלה, הועברו מסרים ליועצים פוליטיים,
              דוברים ועיתונאים על קטאר, מצרים, המו&quot;מ לעסקת החטופים, המלחמה והזירה הפוליטית.
              מסרים אלו נועדו למטרה אחת בלבד - לנהל מבצע השפעה על דעת הקהל בישראל.
            </IntroText>
            <IntroText>
              כל ההודעות המופיעות באתר מבוססות על ציטוטים מדויקים שפורסמו בכלי תקשורת שונים. ממשק
              הווטסאפ הוא אמצעי הצגה, שנועד לאפשר לקרוא את החומר הגולמי ולהבין את רצף
              האירועים בעצמכם.
            </IntroText>
            <ContinueButton disabled={!isReady} onClick={onContinue} type="button">
              {isReady ? "הבנתי, כניסה לפרויקט" : "טוען"}
            </ContinueButton>
          </IntroCardBody>
        </IntroCard>
      </IntroScrollArea>
    </Container>
  );
}
